export default "__VITE_ASSET__FxM6uw6j__"